import { useCallback, useRef } from 'react';
import { StatusCode, type OperationError, type OperationResult } from 'venn-api';
import { Notifications, NotificationType } from 'venn-ui-kit';

const isOperationError = (error: unknown): error is OperationResult<OperationError> =>
  typeof error === 'object' && error !== null && 'status' in error && 'content' in error;

const isForbidden = (error: unknown) => isOperationError(error) && error.status === StatusCode.Forbidden_403;

export const useForbiddenNotification = (message: string) => {
  const toastId = useRef<ReturnType<typeof Notifications.notify>>(undefined);

  return useCallback(
    (error: unknown) => {
      if (!isForbidden(error)) {
        return;
      }
      if (toastId.current !== undefined && Notifications.isActive(toastId.current)) {
        return;
      }
      toastId.current = Notifications.notify(message, NotificationType.ERROR);
    },
    [message],
  );
};
